class TrSlider extends HTMLElement {
	constructor() {
		super();

		this.config = {};
		this.slider = null;
	}

	nameAttributes = {
		config: 'data-config'
	};

	connectedCallback() {
		this.init();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.getConfig();

		this.slider = new Swiper(this, this.config);
	}

	getConfig() {
		try {
			this.config = JSON.parse(this.getAttribute(this.nameAttributes.config));
		} catch (error) {
			console.error('Error parsing JSON:', error);
		}
	}

	destroy() {
		this.slider.destroy();

		this.slider = null;
	}
}

customElements.define('tr-slider', TrSlider);
